import { all } from 'redux-saga/effects';
import dashboardSaga from './Dashboard';
import lcopsSagas from '../components/lcops/sagas';
import lockerSagas from '../components/locker/sagas';
import authznSagas from '../components/authzn/sagas';
import dbServiceSagas from '../components/dbservice/sagas';
import crepoSagas from '../components/crepo/sagas';

export default function* rootSaga() {
  yield all([
    dashboardSaga(),
    ...lcopsSagas(),
    ...lockerSagas(),
    ...authznSagas(),
    ...dbServiceSagas(),
    ...crepoSagas()
  ]);
}
